/** represents common models received from API */

export interface LookupItemDTO<T> {
  itemId: number;
  itemName: string;
  subItems: LookupItemDTO<T>[] | null;
  data: T | null;
}

export interface ApplicationStatusesInitDataDTO<T> {
  applicationStatusLookupItems: ApplicationStatusLookupItemDTO<T>[];
  applicationStatusReasons: ApplicationStatusActiveReasonDTO[];
}

export interface ApplicationStatusLookupItemDTO<T> extends LookupItemDTO<T> {
  canSendEmail: boolean;
  emailTemplateTypeIds: number[] | null;
}

export interface ApplicationStatusActiveReasonDTO {
  applicationStatusReasonId: number;
  name: string;
  isCommentsRequired: boolean;
  applicationStatuses: number[];
}

/** Properties needed to create a Blocklisted Candidate */
export interface BlocklistedCandidateCommand {
  firstName: string;
  lastName: string;
  birthDate: Date | null;
  emailAddress: string | null;
  sabisEntityId: number | null;
  jobRequisitionId: number | null;
}

export interface CommandResult {
  isSucceeded: boolean;
  errors: CommandError[];
}
export interface CommandDataResult<T> extends CommandResult {
  data: T | null;
}
export interface CommandError {
  errorCode: string;
  errorMessage: string;
}

export interface AttachmentDTO {
  storeFileId: string;
  fileName: string;
  fileSize: number;
  downloadUrl: string;
}

export interface AttachedDocumentDTO {
  documentId: number;
  documentTypeName: string;
  documentName: string;
  stepName: string;
  documentTitle: string;
  documentType: DocumentType
  downloadUrl: string;
  documentSource: string;
}

export enum DocumentType {
  document = 1,
  feedbackForm = 2,
  ApplicationForm = 3,
}

export interface EntityTypeAvailabilityDTO {
  availableForSchool: boolean;
  availableForNonSchool: boolean;
}
